const defaultProps = {
  size: 'md',
  variant: 'active',
}

const baseStyle = {
  circle: {
    borderColor: 'sandstone.90',
  },
  icon: {
    borderColor: 'sandstone.45',
  },
}

export const ICON_SIZES = {
  status: { md: 'md', sm: 'sm' },
  iconMode: { md: 'xs', sm: 'xxs' },
} as const

export const sizes = {
  sm: { height: '24px', width: '24px' },
  md: { height: '32px', width: '32px' },
} as const

export const variants = {
  active: {
    circle: {
      bg: 'seaBlue.main',
      borderColor: 'seaBlue.main',
      color: 'white',
    },
    icon: {
      bg: 'white',
      borderColor: 'seaBlue.main',
      color: 'seaBlue.main',
    },
  },
  completed: {
    circle: {
      bg: 'landGreen.41',
      borderColor: 'landGreen.41',
      color: 'white',
    },
    icon: {
      bg: 'white',
      borderColor: 'landGreen.41',
      color: 'landGreen.41',
    },
  },
  optional: {
    circle: {
      bg: 'white',
      borderColor: 'seaBlue.45',
      color: 'seaBlue.45',
    },
    icon: {
      bg: 'white',
      borderColor: 'seaBlue.45',
      color: 'seaBlue.45',
    },
  },
  pending: {
    circle: {
      bg: 'sandstone.90',
      borderColor: 'sandstone.90',
      color: 'sandstone.45',
    },
    icon: {
      bg: 'white',
      borderColor: 'sandstone.45',
      color: 'sandstone.45',
    },
  },
  error: {
    circle: {
      bg: 'energyRed.45',
      borderColor: 'energyRed.45',
      color: 'white',
    },
    icon: {
      bg: 'white',
      borderColor: 'energyRed.45',
      color: 'energyRed.45',
    },
  },
}

export default {
  baseStyle,
  defaultProps,
  sizes,
  variants,
}
